var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 13.8335C4.77801 13.8335 2.16634 11.2218 2.16634 8.00016C2.16634 4.7785 4.77801 2.16683 7.99967 2.16683C11.2213 2.16683 13.833 4.7785 13.833 8.00016C13.833 11.2218 11.2213 13.8335 7.99967 13.8335ZM7.99967 14.6668C11.6816 14.6668 14.6663 11.6821 14.6663 8.00016C14.6663 4.31826 11.6816 1.3335 7.99967 1.3335C4.31778 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.6821 4.31778 14.6668 7.99967 14.6668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 4.66683C8.22979 4.66683 8.41634 4.85338 8.41634 5.0835V7.5835H10.9163C11.1465 7.5835 11.333 7.77004 11.333 8.00016C11.333 8.23028 11.1465 8.41683 10.9163 8.41683H8.41634V10.9168C8.41634 11.1469 8.22979 11.3335 7.99967 11.3335C7.76956 11.3335 7.58301 11.1469 7.58301 10.9168V8.41683H5.08301C4.85289 8.41683 4.66634 8.23028 4.66634 8.00016C4.66634 7.77004 4.85289 7.5835 5.08301 7.5835H7.58301V5.0835C7.58301 4.85338 7.76956 4.66683 7.99967 4.66683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/createIcon.57f463eb4aea2a1d736c4bf27b441b68.svg";
export { ForwardRef as ReactComponent };